import axios from "axios";
import toast from "react-hot-toast";
import { config } from "../../Utils/helpers";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const getBuilderList = (payload = { page: 1, limit: 30 }) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_BUILDER_LIST_REQUEST" });

      const { data } = await axios.post(
        `${BASE_URL}/coupon/builder-list`,
        payload,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "GET_BUILDER_LIST_SUCCESS", payload: data });
        return data;
      } else {
        dispatch({ type: "GET_BUILDER_LIST_FAILED", payload: data });
        toast.error(data.message || "Failed to fetch builder list");
        return data;
      }
    } catch (error) {
      dispatch({ type: "GET_BUILDER_LIST_FAILED", payload: error.message });
      toast.error(error.message || "Failed to fetch builder list");
      return;
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const getProjectListByBuilder = (payload) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_PROJECT_LIST_BY_BUILDER_REQUEST" });

      const { data } = await axios.post(
        `${BASE_URL}/coupon/project-list`,
        payload,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "GET_PROJECT_LIST_BY_BUILDER_SUCCESS", payload: data });
        return data;
      } else {
        dispatch({ type: "GET_PROJECT_LIST_BY_BUILDER_FAILED", payload: data });
        toast.error(data.message || "Failed to fetch project list");
        return data;
      }
    } catch (error) {
      dispatch({ type: "GET_PROJECT_LIST_BY_BUILDER_FAILED", payload: error.message });
      toast.error(error.message || "Failed to fetch project list");
      return;
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};


export const getCategoryList = (payload = { page: 1, limit: 10 }) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_CATEGORY_LIST_REQUEST" });

      const { data } = await axios.post(
        `${BASE_URL}/category/list`,
        payload,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "GET_CATEGORY_LIST_SUCCESS", payload: data });
        return data;
      } else {
        dispatch({ type: "GET_CATEGORY_LIST_FAILED", payload: data });
        toast.error(data.message || "Failed to fetch category list");
        return data;
      }
    } catch (error) {
      dispatch({
        type: "GET_CATEGORY_LIST_FAILED",
        payload: error.message,
      });
      toast.error(error.message || "Failed to fetch category list");
      return;
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const getUnitList = (payload) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_UNIT_LIST_REQUEST" });
      const { data } = await axios.post(
        `${BASE_URL}/coupon/unit-list`,
        payload,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "GET_UNIT_LIST_SUCCESS", payload: data });
        return data;
      } else {
        dispatch({ type: "GET_UNIT_LIST_FAILED", payload: data });
        toast.error(data.message || "Failed to fetch unit list");
        return data;
      }
    } catch (error) {
      dispatch({ type: "GET_UNIT_LIST_FAILED", payload: error.message });
      toast.error(error.message || "Failed to fetch unit list");
      return;
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};



export const viewCouponList = (couponData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "GET_COUPON_LIST_REQUEST" });

      const { data } = await axios.post(
        `${BASE_URL}/coupon/list`,
        couponData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "GET_COUPON_LIST_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_COUPON_LIST_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({ type: "GET_COUPON_LIST_FAILED", payload: error.message });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const addCoupons = (couponData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "ADD_COUPON_REQUEST" });
      const { data } = await axios.post(
        `${BASE_URL}/coupon/add`,
        couponData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "ADD_COUPON_SUCCESS", payload: data });
        toast.success("Added Successfully!");
        return data;
      } else {
        dispatch({ type: "ADD_COUPON_FAILED", payload: data });
        return data;
      }
    } catch (error) {
      dispatch({
        type: "ADD_COUPON_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
      return;
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const viewCoupon = (couponData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "VIEW_COUPON_REQUEST" });
      const { data } = await axios.get(
        `${BASE_URL}/coupon/view/${couponData}`,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "VIEW_COUPON_SUCCESS", payload: data });

        return data;
      } else {
        dispatch({ type: "VIEW_COUPON_FAILED", payload: data });
        return data;
      }
    } catch (error) {
      dispatch({
        type: "VIEW_COUPON_FAILED",
        payload: error?.response?.data?.message,
      });
      return;
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const EditCoupon = (couponData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "EDIT_COUPON_REQUEST" });
      const { data } = await axios.post(
        `${BASE_URL}/coupon/update`,
        couponData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "EDIT_COUPON_SUCCESS", payload: data });
        toast.success("Edit Successful!!");
        return data;
      } else {
        dispatch({ type: "EDIT_COUPON_FAILED", payload: data });
        return data;
      }
    } catch (error) {
      dispatch({
        type: "EDIT_COUPON_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
      return error?.response?.data?.message;
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};
